// Shared categories & genres for Voamada content
export const CATEGORIES = [
  { key: "music", emoji: "🎵", label: "Musique", color: "from-brand-red to-brand-orange" },
  { key: "humor", emoji: "😂", label: "Humour", color: "from-brand-yellow to-brand-orange" },
  { key: "cinema", emoji: "🎬", label: "Cinéma", color: "from-purple-500 to-brand-red" },
  { key: "dance", emoji: "💃", label: "Danse", color: "from-[#0B8B47] to-brand-yellow" },
  { key: "art", emoji: "🎨", label: "Art visuel", color: "from-pink-500 to-brand-red" },
  { key: "fashion", emoji: "👗", label: "Mode", color: "from-rose-500 to-amber-500" },
  { key: "food", emoji: "🍲", label: "Cuisine & recettes", color: "from-amber-500 to-brand-red" },
  { key: "other", emoji: "🎤", label: "Autres talents", color: "from-sky-500 to-[#0B8B47]" },
];

export const CATEGORY_BY_KEY = Object.fromEntries(CATEGORIES.map((c) => [c.key, c]));

// Genres par catégorie (utilisés à l'upload ET comme filtres à l'Explorer)
export const GENRE_SETS = {
  music:   ["Afrobeat", "Rap", "Rap Gasy", "Trap", "Drill", "Hira Gasy", "Gospel", "Salegy", "R&B", "Jazz", "Coupé-Décalé", "Zouk", "Reggae", "Soul", "Pop", "Electro", "Zouglou"],
  humor:   ["Stand-up", "Sketch", "Parodie", "Improvisation", "Vlog humour", "Format court"],
  cinema:  ["Court-métrage", "Web série", "Documentaire", "Clip", "Vlog", "Making-of", "Teaser", "Fiction"],
  dance:   ["Hip-hop", "Danse traditionnelle", "Contemporain", "Afro danse", "Battle", "Chorégraphie", "Ballet", "Salegy danse"],
  art:     ["Peinture", "Dessin", "Photographie", "Graphisme", "Sculpture", "Street art", "Illustration", "Art contemporain"],
  fashion: ["Défilé", "Shooting", "Lookbook", "Collection", "Street style", "Editorial", "Accessoires"],
  food:    ["Cuisine malgache", "Street food", "Pâtisserie", "Végétarien", "Recette rapide", "Plat familial", "Cuisine africaine", "Boissons", "Épices & marinades", "Tutoriel"],
  other:   ["Slam", "Poésie", "Conte", "Magie", "Animation", "Performance", "Théâtre"],
};

export const genresFor = (categoryKey) => GENRE_SETS[categoryKey] || [];

// Types média autorisés par catégorie
export const TYPE_SETS = {
  music: ["audio", "video"],
  humor: ["video", "audio"],
  cinema: ["video"],
  dance: ["video"],
  art: ["image"],
  fashion: ["image", "video"],
  food: ["video", "image"],
  other: ["video", "audio", "image"],
};
